import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'business'

const client = new ApiClient(API_NAME)

export default {
  getEventType(businessId) {
    return client.get(`/${BASE_PATH}/${businessId}/event-type/`)
  },

  getEvent(businessId, type) {
    const query = {}

    query.type = type

    return client.get(`/${BASE_PATH}/${businessId}/event/`, query)
  },

  getReservedEvent(businessId) {
    return client.get(`/${BASE_PATH}/${businessId}/reserved-event/`)
  },

  reserve(businessId, eventId, data) {
    const url = `/${BASE_PATH}/${businessId}/event/${eventId}/reserve/`
    return client.post(url, data)
  },

  cancel(businessId, eventId, data) {
    const url = `/${BASE_PATH}/${businessId}/event/${eventId}/reserve/`
    return client.delete(url, data)
  },
}
